module.exports = __webpack_public_path__ + "img/restaurant.c74513a2.png";